import {useEffect} from "react";

export function LeafletDefaults() {
    useEffect(() => {
        (async () => {
            const L = await import("leaflet");

            const icon = (await import("leaflet/dist/images/marker-icon.png")).default;
            const iconShadow = (await import("leaflet/dist/images/marker-shadow.png")).default;

            L.Marker.prototype.options.icon = L.icon({
                iconUrl: icon,
                shadowUrl: iconShadow,
                iconSize: [25, 41],
                iconAnchor: [13, 41],
            });
        })();
    }, []);

    return null;
}
